export default {
	variant1: ['button-progress-1'],
	variant2: ['button-progress-2']
};
